<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 33px;
        font-weight: bold;
        color: #05523e;
        padding-top: 25px;
      "
    >
      Latest prices
    </v-card-title>

    <div style="margin: 20px 5% 0 5%">
      <div class="description">
        <span>Item Number</span>
        <span>{{ $store.state.invoice.latestPricesList[0].ItemNum }}</span>
      </div>
      <div class="description">
        <span>Description</span>
        <span>{{ currentDescription }}</span>
      </div>
      <v-data-table
        :headers="headers"
        :items="$store.state.invoice.latestPricesList"
        :items-per-page="100"
        hide-default-footer
        class="elevation-3"
        style="margin-top: 20px"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.Company || item.CustNum }}</td>
            <td>{{ item.CostPer || "" }}</td>
            <td>{{ item.PricePer || "" }}</td>
            <td>{{ item.Profit || "" }}</td>
            <td>{{ item.ProfitPer || "" }}</td>
            <td>{{ item.DateTime || "" }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-card-actions style="justify-content: center">
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="$store.commit('common/changeLatestPriceModalView')"
        >Ok</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["currentDescription"],
  created() {},
  methods: {
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Company",
          align: "start",
          value: "CustNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Cost",
          value: "CostPer",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Price",
          value: "PricePer",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Profit",
          value: "Profit",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "ProfitPer(%)",
          value: "ProfitPer",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "DateTime",
          value: "DateTime",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.description {
  display: flex;
  flex-flow: wrap;
}
.description > span:nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  width: 150px;
}
.description > span:nth-child(2) {
  font-size: 20px;
}
.action {
  margin: 0;
}
</style>
